// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getIsLightColor } from '../../common/colors/coreColorUtil';
import { getBackgroundColorCssValue, getIsCustomBackgroundColor } from './background/boardBackgroundUtils';

/**
 * The body background colour will match the board colour so that scrolls in Safari don't show
 * an ugly colour mismatch when it scrolls beyond the canvas edges.
 */
const BodyBackgroundColor = (props) => {
    const { currentBoard } = props;

    const color = getBackgroundColorCssValue(currentBoard);

    React.useEffect(() => {
        if (!document.body) return;

        if (color) {
            document.body.style.setProperty('--ws-canvas-background', color);
        } else {
            document.body.style.removeProperty('--ws-canvas-background');
        }

        if (getIsCustomBackgroundColor(currentBoard)) {
            const isLightBackground = getIsLightColor(color);

            if (isLightBackground) {
                document.body.classList.add('custom-bg-light');
                document.body.classList.remove('custom-bg-dark');
            } else {
                document.body.classList.add('custom-bg-dark');
                document.body.classList.remove('custom-bg-light');
            }
        } else {
            document.body.classList.remove('custom-bg-light', 'custom-bg-dark');
        }
    }, [color]);

    return null;
};

BodyBackgroundColor.propTypes = {
    currentBoard: PropTypes.object,
};

export default BodyBackgroundColor;
